<template>
  <div class="cart-item-wrap-menu">
    <div
      class="mb12 category-header flex-column"
      v-if="selectedCategory"
      :class="{ 'with-bg': selectedCategoryCoverImg.length > 0 }"
      :style="
        selectedCategoryCoverImg.length > 0
          ? { backgroundImage: `url(${selectedCategoryCoverImg})` }
          : {
              backgroundImage: `url(${
                staticImgBaseUrl + '/images/global/menuHeaderBg.svg'
              })`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }
      "
    >
      <div
        class="fw-800 section-header-menu bold"
        :style="{
          color: selectedCategoryImgTitleTextColor || 'white',
        }"
        :class="[selectedCategoryCoverImg.length > 0 ? 'fs-32' : 'fs-16 ']"
      >
        {{ selectedCategory }}
      </div>
      <div
        class="fs-16 fw-400 section-header-menu"
        :style="{
          color: selectedCategoryImgSubTitleTextColor
            ? selectedCategoryImgSubTitleTextColor
            : '',
        }"
      >
        {{ selectedCategoryImgSubTitleText }}
      </div>
    </div>
    <div
      class="cards-holder-menu"
      v-if="getOneCategoryProductItems(getCategoryNodeId)?.length"
    >
      <hongs-product-card
        v-for="(value, index) in getOneCategoryProductItems(getCategoryNodeId)"
        :key="index"
        :data-item="value"
        :data-item-index="index"
        :data-cardRounded="productCardProps.cardRounded"
        :data-smallCards="productCardProps.smallCards"
        :data-hideImage="productCardProps.hideImage"
        :showFullInfo="true"
        :data-counterText="getCategoryNodeId"
        :data-categoryId="getCategoryNodeId"
        :data-module-props="modulePropsParsed"
        :data-category-name="selectedCategory"
      ></hongs-product-card>
      <div class="static-text-menu">{{ staticTextCategory }}</div>
    </div>
    <div
      v-else-if="getSubCategoryItems(getCategoryNodeId)?.length"
      v-for="(item, index) in getSubCategoryItems(getCategoryNodeId)"
      :key="index"
    >
      <h3
        class="card-catg-name pt5"
        :class="{
          subCategory: item.isSubCategory,
        }"
        v-if="getOneCategoryProductItems(item?.nodeId)?.length > 0"
      >
        {{ item?.nodeName?.split("_").join(" ") }}
        <span v-if="getOneCategoryProductItems(item?.nodeId)?.length > 0"
          >({{ getOneCategoryProductItems(item?.nodeId).length }})</span
        >
      </h3>
      <div class="cards-holder-menu">
        <hongs-product-card
          v-for="(value, subIndex) in getOneCategoryProductItems(item?.nodeId)"
          :key="subIndex"
          :data-item="value"
          :data-item-index="subIndex"
          :data-cardRounded="productCardProps.cardRounded"
          :data-smallCards="productCardProps.smallCards"
          :data-hideImage="productCardProps.hideImage"
          :showFullInfo="true"
          :data-counterText="item?.nodeId"
          :data-categoryId="item?.nodeId"
          :data-module-props="modulePropsParsed"
          :data-category-name="selectedCategory"
        ></hongs-product-card>
      </div>
      <div class="static-text-menu">{{ staticTextCategory }}</div>
    </div>

    <div v-else class="mt80">
      <div class="tc">
        <img :src="staticImgBaseUrl + '/images/global/img-empty-fav.svg'" />
      </div>
      <div class="fs-14 title lh21 tc">Oops! No such item present</div>
    </div>
    <!-- item add/remove toast msg -->
    <toast-msg
      v-if="showItemToastMsg"
      :data-img="staticImgBaseUrl + '/images/global/itemToastIcon.svg'"
      :data-text="itemToastMsg"
      :data-style="'item-toast-msg'"
      :data-text-color="'textWhite'"
    ></toast-msg>
  </div>
</template>

<script>
import HongsProductCard from "./HongsProductCard.vue";
import Utility from "../helpers/utility";
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import { staticImgBaseUrl, showItemToast } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { defineAsyncComponent } from "vue";
import { setEvents } from "../helpers/analyticsEvents";
import { DISABLED_ORDER_TYPE } from "../helpers/OrderStatusConstants";

export default {
  name: "VerticalProductsScrollMenu",
  components: {
    HongsProductCard,
    ToastMsg: defineAsyncComponent(() => import("./ToastMsg.vue")),
  },
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      productCardProps: {
        cardRounded: true,
        smallCards: false,
        hideImage: false,
      },
      staticImgBaseUrl,
      isEventLogged: true,
      staticText: "",
    };
  },
  watch: {
    appliedFilters() {
      this.$nextTick(() => {
        this.redirectToFirstCategoryIfEmpty();
      });
    },
  },
  mounted() {
    this.modulePropsParsed = JSON.parse(this.moduleProps);
    this.staticText = this.modulePropsParsed?.title;
    this.loadData = Utility.tryJsonParse(this.dataResults, []);
    this.processResultDataForStore(this.loadData);
    if (LocalStorageFunc.isLoggedIn()) {
      this.$store.dispatch(keyMapsAction.GET_FAVOURITE_IDS_API, {});
    } else {
      this.$store.commit(
        keyMapsMutation.MARK_FAVOURITE_IDS,
        LocalStorageFunc.getFavouriteIds(),
      );
    }
    // let queryParams = Utility.getQueryFromUrl();
    // if (queryParams["category"]) {
    //   this.$store.commit(
    //     keyMapsMutation.UPDATE_CLICKED_CATEGORY_ANCHOR_LINK,
    //     queryParams["category"]?.split("+").join(" ")
    //   );
    //   this.$store.commit(
    //     keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
    //     queryParams["category"]?.split("+").join(" ")
    //   );
    // }
    setTimeout(
      () => document.body.classList.remove("body-stop-scroll-mobile"),
      3500,
    );
  },
  methods: {
    processResultDataForStore(data) {
      this.$store.commit(keyMapsMutation.UPDATE_PRODUCTS_IN_STORE, data);
      this.$store.commit(keyMapsMutation.LOAD_CART_FROM_STORAGE_SERVICE, data);
      this.$store.commit(
        keyMapsMutation.UPDATE_IMG_BASE_URL,
        data?.mediaBaseURL,
      );
    },
    getOneCategoryProductItems(categoryId) {
      const oneCategoryProductItems =
        this.$store.getters[keyMapsGetter.GET_PRODUCTS][categoryId];

      if (
        oneCategoryProductItems &&
        Object.keys(oneCategoryProductItems).length &&
        this.isEventLogged
      ) {
        this.isEventLogged = false;
        setEvents("meta", "FB_ViewContent", {});
      }

      const products = this.$store.state.ProductItems.productCategory.find(
        (x) => x.nodeId === categoryId,
      )?.children;

      if (!products) return [];
      let filteredProducts = [];
      if (
        oneCategoryProductItems &&
        Object.keys(oneCategoryProductItems).length
      ) {
        filteredProducts = products
          .map((product) => oneCategoryProductItems[product?.skuId])
          .filter((product) => !this.isItemDisabled(product))
          .filter(Boolean);
      }

      return filteredProducts;
    },
    isItemDisabled(item) {
      let deliveryType = LocalStorageFunc.getDeliveryType();
      let isItemDisabled = false;
      item?.disabledOrderTypes.map((x) => {
        if (DISABLED_ORDER_TYPE[x] === deliveryType) isItemDisabled = true;
      });
      item?.variants &&
        item?.variants.map((i) =>
          i.disabledOrderTypes.map((x) => {
            if (DISABLED_ORDER_TYPE[x] === deliveryType) isItemDisabled = true;
          }),
        );
      return isItemDisabled;
    },
    getSubCategoryItems(categoryId) {
      return this.$store.state.ProductItems.productCategory.filter(
        (x) => x.parentNodeId === categoryId,
      );
    },
    getCountProduct(getCategoryNodeId) {
      let count =
        this.getOneCategoryProductItems(getCategoryNodeId)?.length ||
        this.getSubCategoryItems(getCategoryNodeId).reduce((total, item) => {
          const products = this.getOneCategoryProductItems(item?.nodeId);
          return total + products?.length;
        }, 0);
      if (!count) {
        this.redirectToFirstCategoryIfEmpty();
      }
      return count;
    },
    redirectToFirstCategoryIfEmpty() {
      const currentNodeId = this.getCategoryNodeId;
      if (!currentNodeId) return;

      const count =
        this.getOneCategoryProductItems(currentNodeId)?.length ||
        this.getSubCategoryItems(currentNodeId).reduce((total, item) => {
          return (
            total + (this.getOneCategoryProductItems(item?.nodeId)?.length || 0)
          );
        }, 0);

      if (!count) {
        const categories = this.getCategoryNameAndCountForBottomBar();
        const firstWithProducts = categories?.find(
          (x) => x.count > 0 && x.visible,
        );
        if (!firstWithProducts) return;

        this.$store.commit(
          keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
          firstWithProducts.categoryName,
        );
        this.$store.commit(
          keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS,
          true,
        );
        this.$store.commit(
          keyMapsMutation.UPDATE_CLICKED_CATEGORY_ANCHOR_LINK,
          firstWithProducts.categoryName,
        );

        let scrollTopMargin = window.screen.width <= 321 ? 70 : 102;
        Utility.scrollUptoTo(
          "element_catg_" + firstWithProducts.nodeId,
          scrollTopMargin,
        );
      }
    },
    getCategoryNameAndCountForBottomBar() {
      let productItems =
        this.$store.getters[
          keyMapsGetter.GET_CATEGORY_NAME_AND_COUNT_FOR_BOTTOM_BAR
        ];
      return productItems;
    },
  },
  computed: {
    appliedFilters() {
      return this.$store.getters[keyMapsGetter.GET_APPLIED_FILTERS];
    },
    selectedCategory() {
      let categories = this.getCategoryNameAndCountForBottomBar();
      return (
        this.$store.state.Menu.clickedCategoryAnchorLink ||
        categories?.find((x) => x.count)?.categoryName
      );
    },
    staticTextCategory() {
      return `${this.staticText} in ${this.selectedCategory}`;
    },
    selectedCategoryCoverImg() {
      const category = this.$store.state.ProductItems.productCategory.find(
        (x) => x.nodeName === this.selectedCategory,
      );

      if (!category?.mediaList?.length) return "";

      // Find the media item with tAppCategoryCover URL
      const coverImage = category.mediaList.find(
        (media) => media.mediaUrls?.tAppCategoryCover,
      );

      if (coverImage) {
        return (
          this.$store.state.ProductItems.imgBaseUrl +
          coverImage.mediaUrls.tAppCategoryCover
        );
      }

      return "";
    },
    selectedCategoryImgSubTitleText() {
      const category = this.$store.state.ProductItems.productCategory.find(
        (x) => x.nodeName === this.selectedCategory,
      );

      if (!category?.mediaList?.length) return "";

      // Find the media item with tAppCategoryCover URL and metadata
      const coverImage = category.mediaList.find(
        (media) =>
          media.mediaUrls?.tAppCategoryCover &&
          media.metadataMap?.image_subtitle_text,
      );

      if (coverImage?.metadataMap?.image_subtitle_text?.values?.[0]) {
        return coverImage.metadataMap.image_subtitle_text.values[0];
      }

      return "";
    },
    selectedCategoryImgSubTitleTextColor() {
      const category = this.$store.state.ProductItems.productCategory.find(
        (x) => x.nodeName === this.selectedCategory,
      );

      if (!category?.mediaList?.length) return "";

      // Find the media item with tAppCategoryCover URL and metadata
      const coverImage = category.mediaList.find(
        (media) =>
          media.mediaUrls?.tAppCategoryCover &&
          media.metadataMap?.image_subtitle_text_color,
      );

      if (coverImage?.metadataMap?.image_subtitle_text_color?.values?.[0]) {
        return coverImage.metadataMap.image_subtitle_text_color.values[0];
      }

      return "";
    },
    selectedCategoryImgTitleTextColor() {
      const category = this.$store.state.ProductItems.productCategory.find(
        (x) => x.nodeName === this.selectedCategory,
      );

      if (!category?.mediaList?.length) return "";

      // Find the media item with tAppCategoryCover URL and metadata
      const coverImage = category.mediaList.find(
        (media) =>
          media.mediaUrls?.tAppCategoryCover &&
          media.metadataMap?.image_title_text_color,
      );

      if (coverImage?.metadataMap?.image_title_text_color?.values?.[0]) {
        return coverImage.metadataMap.image_title_text_color.values[0];
      }

      return "";
    },
    // productCategories() {
    //   let pCategories = this.$store.state.ProductItems.productCategory;

    //   if (!pCategories?.length) {
    //     let pMapShort = this.$store.state.ProductItems.productCategoryMapShort;
    //     return Object.keys(pMapShort).map((key) => {
    //       return { nodeId: key, nodeName: pMapShort[key] };
    //     });
    //   }
    //   return pCategories;
    // },
    getCategoryNodeId() {
      return (
        this.$store.state.ProductItems.productCategory?.length &&
        this.$store.state.ProductItems.productCategory.find(
          (x) => x.nodeName === this.selectedCategory,
        ).nodeId
      );
    },
    productCategory() {
      return this.$store.state.ProductItems.productCategory;
    },
    itemToastMsg() {
      return this.$store.state.Cart.itemToastMsg;
    },
    showItemToastMsg() {
      return this.$store.state.Cart.showItemToastMsg && showItemToast;
    },
  },
};
</script>
